import { useState } from "react";
import Image from "react-bootstrap/Image";
import Button from "react-bootstrap/Button";
import { submitLead } from "../leadService";
import { Row, Col } from "react-bootstrap";
import Form from "react-bootstrap/Form";
import LayerFour from "../assets/images/layers/Layer_4.png";

const SmartSolutionsModal = () => {
  const [isSubmitted, setIsSubmitted] = useState(false);

  const [formData, setFormData] = useState({
    name: "",
    email: "",
    company: "",
    solution: "",
    mobile: "",
    notes: "",
  });

  const [loading, setLoading] = useState(false);
  const [responseMessage, setResponseMessage] = useState("");
  const [errors, setErrors] = useState({});

  const businessEmailRegex =
    /@(gmail\.com|yahoo\.com|outlook\.com|hotmail\.com|aol\.com|icloud\.com|protonmail\.com|zoho\.com|mail\.com|gmx\.com)$/i;

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const validateForm = () => {
    const newErrors = {};

    if (!formData.name?.trim()) {
      newErrors.name = "Full Name is required";
    }

    if (!formData.email?.trim()) {
      newErrors.email = "Business Email is required";
    } else if (businessEmailRegex.test(formData.email)) {
      newErrors.email = "Please use a business email address";
    }

    if (!formData.company?.trim()) {
      newErrors.company = "Company Name is required";
    }

    if (!formData.solution) {
      newErrors.solution = "Please select the Smart Solution you’re interested in";
    }

    const phoneNumber = formData.mobile || "";
    if (phoneNumber && !/^\d{10}$/.test(phoneNumber.replace(/[^\d]/g, ""))) {
      newErrors.mobile = "Please enter a valid 10-digit phone number";
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setResponseMessage("");
    setErrors({});

    const { email } = formData;

    if (!validateForm()) {
      setLoading(false);
      setResponseMessage("Please correct the errors in the form.");
      return;
    }

    if (businessEmailRegex.test(email)) {
      setResponseMessage("Please enter a valid business email address.");
      setLoading(false);
      return;
    }


    try {
      const response = await submitLead("smart-solutions", formData);
      if (response.success) {
        setResponseMessage("Form submitted successfully!");
        setIsSubmitted(true);
        setTimeout(() => {
          setResponseMessage("");
        }, 3000);

        setFormData({
          name: "",
          email: "",
          company: "",
          solution: "",
          mobile: "",
          notes: "",
        });
      } else {
        setResponseMessage(response.message);
      }
    } catch (error) {
      setResponseMessage("An error occurred. Please try again.");
    }

    setLoading(false);
  };

  return (
    <>
      <div className="bg-E2F1FE position-relative box-shadow-one rounded-4 pt-5 p-23 p-sm-23">
        <Image
          src={LayerFour}
          className="position-absolute bottom-0 start-0 w-40"
        />

        <Row className="position-relative form-box z-0">
          {isSubmitted ? null : (
            <Col lg={5}>
              <div className="text-left d-flex justify-content-start">
                <h2 className="section-heading fw-700 fs-2">
                  Book Your{" "}
                  Smart Solutions{" "}
                  <span className="bordered-text bordered-text-start">
                    Consultation
                  </span>{" "}

                </h2>
              </div>
            </Col>
          )}
          <Col lg={isSubmitted ? 12 : 7}>
            {isSubmitted ? (
              <div className="text-center py-5">
                <div className="d-flex flex-column align-items-center">
                  <h2 className="section-heading fw-700 fs-2 mb-4">
                    <span className="bordered-text">Thank You!</span>
                  </h2>
                  <p className="fs-4 fw-700 mb-2">
                    Your Smart Solutions consultation request has been received.
                  </p>
                  <p className="fs-5 fw-700">
                    Our team will get back to you shortly.
                  </p>
                </div>
              </div>
            ) : (
              <Form onSubmit={handleSubmit}>
                <Row className="pb-3 mt-3 mt-lg-0">
                  <Col lg={6}>
                    <>
                      <Form.Label htmlFor="name">
                        Full Name <span className="text-danger">*</span>
                      </Form.Label>
                      <Form.Control
                        type="text"
                        name="name"
                        value={formData.name}
                        onChange={handleChange}
                        isInvalid={!!errors.name}
                      />
                      <Form.Control.Feedback type="invalid">
                        {errors.name}
                      </Form.Control.Feedback>
                    </>
                  </Col>
                  <Col lg={6}>
                    <>
                      <Form.Label>
                        Business Email <span className="text-danger">*</span>
                      </Form.Label>
                      <Form.Control
                        type="email"
                        name="email"
                        value={formData.email}
                        onChange={handleChange}
                        isInvalid={!!errors.email}
                      />
                      <Form.Control.Feedback type="invalid">
                        {errors.email}
                      </Form.Control.Feedback>
                    </>
                  </Col>
                  <Col lg={6}>
                    <>
                      <Form.Label htmlFor="company">
                        Company Name <span className="text-danger">*</span>
                      </Form.Label>
                      <Form.Control
                        type="text"
                        name="company"
                        value={formData.company}
                        onChange={handleChange}
                        isInvalid={!!errors.company}
                      />
                      <Form.Control.Feedback type="invalid">
                        {errors.company}
                      </Form.Control.Feedback>
                    </>
                  </Col>
                  <Col lg={6}>
                    <Form.Group className="mb-3">
                      <Form.Label>Contact Number</Form.Label>
                      <Form.Control
                        type="tel"
                        placeholder="Enter 10-digit phone number"
                        name="mobile"
                        value={formData.mobile}
                        onChange={(e) => {
                          const value = e.target.value
                            .replace(/[^\d]/g, "")
                            .slice(0, 10);
                          setFormData({ ...formData, mobile: value });
                        }}
                        isInvalid={!!errors.mobile}
                        className="rounded-1 custom-input custom-input-two"
                      />
                      {errors.mobile && (
                        <Form.Control.Feedback type="invalid">
                          {errors.mobile}
                        </Form.Control.Feedback>
                      )}
                    </Form.Group>
                  </Col>
                  <Col lg={6}>
                    <Form.Group className="mb-3">
                      <Form.Label>
                        Which Smart Solution are you interested in?{" "}
                        <span className="text-danger">*</span>
                      </Form.Label>
                      <Form.Select
                        name="solution"
                        value={formData.solution}
                        onChange={handleChange}
                        className="rounded-1 custom-input custom-input-two"
                        isInvalid={!!errors.solution}
                      >
                        <option value="" disabled>
                          Select
                        </option>
                        <option value="Data Cloud Maturity Assessment">
                          Data Cloud Maturity Assessment
                        </option>
                        <option value="AppLink – Flutter SDK">
                          AppLink – Flutter SDK
                        </option>
                        <option value="LyncSense – Link Shortener & Tracking">
                          LyncSense – Link Shortener & Tracking
                        </option>
                        <option value="Data De-duplication Engine (PySpark)">
                          Data De-duplication Engine (PySpark)
                        </option>
                        <option value="AWS Middleware for Salesforce Data Cloud">
                          AWS Middleware for Salesforce Data Cloud
                        </option>
                        <option value="Not sure / need guidance">
                          Not sure / need guidance
                        </option>
                      </Form.Select>
                      {errors.solution && (
                        <Form.Control.Feedback type="invalid">
                          {errors.solution}
                        </Form.Control.Feedback>
                      )}
                    </Form.Group>
                  </Col>

                  <Col lg={12} className="mt-4 text-start">
                    <>
                      <Button
                        variant=""
                        type="submit"
                        className="fw-600 d-block btn btn-danger btn-xl"
                        disabled={loading}
                      >
                        {loading ? "Submitting..." : "Submit"}
                      </Button>
                    </>
                  </Col>
                  {responseMessage && (
                    <p
                      className="mt-3 mb-0 fs-12 text-center"
                      style={{ color: loading ? "blue" : "red" }}
                    >
                      {responseMessage}
                    </p>
                  )}
                </Row>
              </Form>
            )}
          </Col>
        </Row>
      </div>
    </>
  );
};

export default SmartSolutionsModal;


